import React, { useEffect, useState, useRef, useMemo, Fragment } from 'react';

import {
  Card,
  CardContent,
  CardHeader,
  CardActions,
  FormControl,
  InputLabel,
  Box,
  Select,
  Alert,
  Snackbar,
  MenuItem,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { v4 } from 'uuid';
import Loading from 'util/loading';
import { API } from 'aws-amplify';

import * as customQueries from 'graphql/custom/queries';
import * as customGql from 'graphql/custom/functions';

import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';

function initialDate() {
  let dt = new Date();
  dt.setDate(10);
  dt.setMonth(dt.getMonth() - 1);
  return dt;
}

const styles = {
  topBox: {
    columnGap: 12,
    '&:hover': {
      backgroundColor: '#eaeaea',
    },
  },
};

const WarningItem = (props) => {
  const [alert, setAlert] = useState({
    severity: 'info',
    message: '',
    open: false,
  });

  // data selecionada
  const iDate = initialDate();
  const [refDate, setRefDate] = useState(iDate);

  const [loading, setLoading] = useState(false);

  const [operators, setOperators] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState('');
  const [dialogOpened, setDialogOpened] = useState(false);
  const [fileUrl, setFileUrl] = useState(``);
  const [count, setCount] = useState(0);

  // inicial - pega a lista de programadoras
  useEffect(() => {
    updateOperatorsList();

    return function cleanup() {};
  }, []);

  useEffect(() => {
    setCount(0);
    setFileUrl('');

    return function cleanup() {};
  }, [refDate, selectedOperator]);

  function compare(a, b) {
    if (a.trade > b.trade) return 1;
    if (b.trade > a.trade) return -1;

    return 0;
  }

  const updateOperatorsList = async function () {
    try {
      setLoading(true);
      const result = await customGql.listAll(customQueries.listOperators);
      setOperators(result.sort(compare));
    } catch (error) {
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const retrieveWarnings = async function () {
    try {
      if (!selectedOperator || selectedOperator.length === 0) return;

      setLoading(true);

      const m = (refDate.getMonth() + 1).toString().padStart(2, '0');
      const y = refDate.getFullYear().toString();
      const period = y + '-' + m;

      const apiName = 'lambdasApi';
      const path = '/warnings';
      const options = {
        body: {
          operatorId: selectedOperator,
          period: period,
        },
        headers: {},
      };
      const response = await API.post(apiName, path, options);
      console.log(response);

      setCount(response.count);
      setFileUrl(response.url);

      setDialogOpened(true);
    } catch (error) {
      setAlert({
        message: error.toString(),
        severity: 'error',
        open: true,
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // quando usuário clica no botão para mudar o mês
  function handleChangeMonth(event) {
    const m = event.target.value;
    const d = new Date(refDate);
    d.setMonth(m);
    setRefDate(d);
  }

  // quando usuário clica no botão para mudar o ano
  function handleChangeYear(event) {
    const y = event.target.value;
    const d = new Date(refDate);
    d.setFullYear(y);
    setRefDate(d);
  }

  const handleChangeOperator = function (aEvent) {
    setSelectedOperator(aEvent.target.value);
  };

  // quando usuário clica no botão para fechar o alerta
  function handleCloseAlert(event) {
    setAlert({
      message: '',
      severity: 'info',
      open: false,
    });
  }

  function handleCloseDialog(event) {
    setDialogOpened(false);
  }

  // retorna os anos a partir de 2020
  function getYearsList() {
    const years = [];
    for (let i = new Date().getFullYear(); i >= 2020; i--) {
      years.push(i);
    }
    return years;
  }

  return (
    <Fragment>
      <Loading loading={Boolean(loading)} />

      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={(e) => handleCloseAlert(e)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Alert severity={alert.severity}>{alert.message}</Alert>
      </Snackbar>

      <Card className="shadow border-0">
        <CardContent>
          <Box display="flex" flexDirection="row" sx={styles.topBox}>
            <FormControl className="w-100" variant="standard">
              <InputLabel>Mês</InputLabel>
              <Select
                name="month"
                value={refDate.getMonth()}
                onChange={(e) => handleChangeMonth(e)}
                variant="standard"
                sx={{
                  width: 180,
                }}
              >
                {[...Array(12).keys()].map((item, idx) => (
                  <MenuItem key={idx} value={idx}>
                    {(idx + 1).toString().padStart(2, '0')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className="w-100" variant="standard">
              <InputLabel>Ano</InputLabel>
              <Select
                name="year"
                value={refDate.getFullYear()}
                onChange={(e) => handleChangeYear(e)}
                variant="standard"
                sx={{
                  width: 180,
                }}
              >
                {getYearsList().map((item, idx) => (
                  <MenuItem key={idx} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className="w-100" variant="standard">
              <InputLabel>Operadora</InputLabel>
              <Select
                name="operator"
                value={selectedOperator}
                onChange={(e) => handleChangeOperator(e)}
                variant="standard"
                sx={{
                  width: 180,
                }}
              >
                {operators.map((item, idx) => (
                  <MenuItem key={idx} value={item.id}>
                    {item.trade}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <Button variant="contained" onClick={() => retrieveWarnings()}>
                Buscar registros
              </Button>
            </FormControl>
          </Box>
        </CardContent>
      </Card>

      <Dialog
        open={dialogOpened}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
      >
        <DialogTitle id="alert-dialog-title">{'Planilha de alertas'}</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <a href={fileUrl}>Clique aqui para baixar a planilha</a>
          </Typography>
          <Typography gutterBottom>Quantidade de registros: {count}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} autoFocus>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default WarningItem;
